import React from 'react';
import PropTypes from 'prop-types';
import {
  AutoCompleteSuggestionItem,
  MaterialIcon,
} from '@pearsontechnology/aero-components';

import {
  TeamIcon,
  RowContent,
  RowActions,
  Name,
} from '../styles';

const TeamRow = ({ data: { id, text, role } }) => (
  <AutoCompleteSuggestionItem id={id}>
    <RowContent>
      <TeamIcon>
        <MaterialIcon id={'group'} />
      </TeamIcon>
      <Name>{ text }</Name>
    </RowContent>
    <RowActions>
      { role }
    </RowActions>
  </AutoCompleteSuggestionItem>
);

TeamRow.propTypes = {
  data: PropTypes.object.isRequired,
};

export default TeamRow;
